export interface RuntimeConfig {
  apiBaseUrl: string;
  awsRegion: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
  appTitle: string;
  appBaseUrl: string;
  adminBaseUrl: string;
  buildId: string;
  dailyNotificationDefaultTime: string;
}

declare global {
  interface Window {
    GOVVUE_CONFIG?: Partial<RuntimeConfig>;
  }
}

const raw = window.GOVVUE_CONFIG ?? {};

export const runtimeConfig: RuntimeConfig = {
  apiBaseUrl: raw.apiBaseUrl ?? '',
  awsRegion: raw.awsRegion ?? 'us-east-1',
  userPoolId: raw.userPoolId ?? '',
  userPoolClientId: raw.userPoolClientId ?? '',
  cognitoDomain: raw.cognitoDomain ?? '',
  appTitle: raw.appTitle ?? 'GovVue Light',
  appBaseUrl: raw.appBaseUrl ?? 'https://app.govvue.com',
  adminBaseUrl: raw.adminBaseUrl ?? 'https://admin.govvue.com',
  buildId: raw.buildId ?? 'local',
  dailyNotificationDefaultTime: raw.dailyNotificationDefaultTime ?? '06:15',
};
